import actions from '../../actionTypes';

export default () => {
  return {
    type: actions.CLEAR_FILTERS
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/clearFilters.js